import { Theme as AugmentedTheme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { Box, Grid, KeyValue, Typography } from 'web-library';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles()((theme) =>
({
  container: {},
  sectionTitle: {
    marginBottom: theme.spacing(4),
  },
}));

export interface SimpleCandidateDetailProps {
  name: string;
  id: string;
  indexNo: string;
  citizenshipType?: string;
}

const SimpleCandidateDetail = ({
  name,
  id,
  indexNo,
  citizenshipType = '',
}: SimpleCandidateDetailProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();

  return (
    <Box className={classes.container}>
      <Typography className={classes.sectionTitle} variant="h3">
        {t('components->>SimpleCandidateDetail.Candidate Details')}
      </Typography>
      <Grid container>
        <Grid md={6} xs={12}>
          <KeyValue
            id="candidateName"
            keyText={t('components->>SimpleCandidateDetail.Candidate Name')}
            valueText={name}
          />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue
            id="citizenshipType"
            keyText={t('components->>SimpleCandidateDetail.Citizenship Type')}
            valueText={citizenshipType.toString()}
          />
        </Grid>

        <Grid md={6} xs={12}>
          <KeyValue
            id="nricFinPassport"
            keyText={t('components->>SimpleCandidateDetail.NRIC/FIN/Passport No.')}
            valueText={id}
          />
        </Grid>
        <Grid md={6} xs={12}>
          <KeyValue
            id="indexNo"
            keyText={t('components->>SimpleCandidateDetail.Index No.')}
            valueText={indexNo}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SimpleCandidateDetail;
